import { gql } from "@apollo/client";

export const LOGIN_USER = gql`
mutation UserLogin($data: UserLoginInput!) {
  userLogin(data: $data) {
    accessToken
  }
}
`;